export default [
  {
    path: '/openapi/dashboard',
    name: 'dashboard-open-api',
    component: () => import('@/views/pages/open-api/dashboard/ListCollaborator.vue'),
    meta: {
      resource: 'Open Api - Dashboard',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/collaborator/detail/:id',
    name: 'dashboard-open-api',
    component: () => import('@/views/pages/open-api/dashboard/DetailCollaborator.vue'),
    meta: {
      resource: 'Open Api - Dashboard',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/user-tracker',
    name: 'doc-request-collaborator',
    component: () => import('@/views/pages/open-api/document-request/ListRequest.vue'),
    meta: {
      resource: 'Open Api - User Tracker',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/user-tracker/detail/:id',
    name: 'doc-request-collaborator',
    component: () => import('@/views/pages/open-api/document-request/DetailRequest.vue'),
    meta: {
      resource: 'Open Api - User Tracker',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/user-tracker/detail/history/:id',
    name: 'doc-request-collaborator',
    component: () => import('@/views/pages/open-api/document-request/HistoryUser.vue'),
    meta: {
      resource: 'Open Api - User Tracker',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/system-update-log',
    name: 'system-update-log',
    component: () => import('@/views/pages/open-api/system-update-log/List.vue'),
    meta: {
      resource: 'Open Api - System Update Log',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/system-update-log/create',
    name: 'system-update-log-add',
    component: () => import('@/views/pages/open-api/system-update-log/Add.vue'),
    meta: {
      resource: 'Open Api - System Update Log',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
  {
    path: '/openapi/system-update-log/:id',
    name: 'system-update-log-detail',
    component: () => import('@/views/pages/open-api/system-update-log/Add.vue'),
    meta: {
      resource: 'Open Api - System Update Log',
      navActiveLink: 'open-api',
      action: 'manage',
    },
  },
]
